/**
 * 关键词、竞品、SKU分组、指标定义 API
 */

import api from './client';
import type { Keyword, CompetitorASIN, SKUGroup, MetricDefinition } from '../../types';

export const keywordAPI = {
    list: (params?: { period_id?: number; sku_id?: number; search?: string }) =>
        api.get<Keyword[]>('/keywords/', { params }),
    get: (id: number) => api.get<Keyword>(`/keywords/${id}/`),
};

export const competitorAPI = {
    list: (params?: { sku?: number; threat_level?: string }) =>
        api.get<CompetitorASIN[]>('/competitor-asins/', { params }),
    get: (id: number) => api.get<CompetitorASIN>(`/competitor-asins/${id}/`),
    create: (data: Partial<CompetitorASIN>) => api.post<CompetitorASIN>('/competitor-asins/', data),
    update: (id: number, data: Partial<CompetitorASIN>) =>
        api.patch<CompetitorASIN>(`/competitor-asins/${id}/`, data),
    delete: (id: number) => api.delete(`/competitor-asins/${id}/`),
    syncDetails: (id: number) => api.post<{ status: string; message: string; data: CompetitorASIN }>(`/competitor-asins/${id}/sync_details/`),
};

export const skuGroupAPI = {
    list: () => api.get<SKUGroup[]>('/sku-groups/'),
    get: (id: number) => api.get<SKUGroup>(`/sku-groups/${id}/`),
    create: (data: Partial<SKUGroup>) => api.post<SKUGroup>('/sku-groups/', data),
    update: (id: number, data: Partial<SKUGroup>) => api.patch<SKUGroup>(`/sku-groups/${id}/`, data),
    delete: (id: number) => api.delete(`/sku-groups/${id}/`),
};

export const metricsDefinitionAPI = {
    list: () => api.get<Record<string, MetricDefinition>>('/metrics-definitions/'),
    getByCategory: (category?: string) => {
        const params = category ? { category } : {};
        return api.get<Record<string, MetricDefinition>>('/metrics-definitions/by_category/', { params });
    },
};
